import React from 'react';
import './Input.css';

export function Input({ label, ...props }) {
  return (
    <label className="input-label">
      {label && <span>{label}</span>}
      <input className="styled-input" {...props} />
    </label>
  );
}

export default Input;